export const SKILL_LEVEL_MODEL = "skill-level";

const skillLevelModel = {
  name: ""
};

export default skillLevelModel;
